import React from "react";
import { FiTruck } from "react-icons/fi";
import { useTenant } from "../../context/TenantContext";

const isEnabled = (value) =>
  value === true ||
  value === 1 ||
  ["true", "1"].includes(String(value || "").toLowerCase());

const ProductDeliveryPromo = ({ className = "" }) => {
  const { settings } = useTenant();
  const threshold = Number(
    settings?.DeliveryPromoThreshold ??
      settings?.deliveryPromoThreshold ??
      500,
  );

  if (
    !isEnabled(settings?.ShowDeliveryPromo ?? settings?.showDeliveryPromo) ||
    !Number.isFinite(threshold) ||
    threshold <= 0
  ) {
    return null;
  }

  const formattedThreshold = new Intl.NumberFormat("en-ZA", {
    maximumFractionDigits: 2,
  }).format(threshold);

  return (
    <span className={`qv-delivery product-delivery-promo ${className}`.trim()}>
      <FiTruck size={14} aria-hidden="true" />
      Free delivery over R{formattedThreshold}
    </span>
  );
};

export default ProductDeliveryPromo;
